module.exports = __webpack_public_path__ + "img/team-7.a6d2c8e6.png";